import { h, Component } from 'preact'
import Headline from '../components/Headline'
import Panel from '../components/Panel'
import ColorPicker from '../components/ColorPicker'
import Product from '../components/Product'
import Button from '../components/Button'
import MountOptions from '../components/MountOptions'
import { Text } from 'preact-i18n'
import TypePicker from '../components/TypePicker'
import Hints from '../components/Hints'

const unique = (eq = a => b => a == b) => (array = []) =>
    array.filter((x, i) => array.findIndex(eq(x)) == i)
    
const eqKey = key => a => {
    let val = a[key];
    return b => b[key] == val;
}

const uniqueByKey = key => unique(eqKey(key))

const typeOptions = uniqueByKey('type')
const colorOptions = uniqueByKey('color')

export default class ChooseMount extends Component {
    constructor(props) {
        super(props)

        this.selectMount = mount => {
            if (mount) this.props.setState({mount});
        }
    
        this.selectMountType = ({type}) => {
            let {config: {options: {mount: mounts = []}}} = this.context
            let {state: {mount = {}}} = this.props
    
            this.selectMount(mounts.find(x => 
                x.color == mount.color && 
                x.type == type
            ))
        }
    
        this.selectMountColor = ({color}) => {
            let {config: {options: {mount: mounts = []}}} = this.context
            let {state: {mount = {}}} = this.props
    
            this.selectMount(mounts.find(x => 
                x.color == color && 
                x.type == mount.type
            ))
        }
    }
        

    render ({state: { mount }, goto}, _, {config: {options: {mount: mounts}}}) {
        return (
            <div class="limba__choose-mount container" key="container">
                <Product mount={mount} />
                <div class="limba__controls" key="controls">
                    <Headline />
                    <Panel key="mountOptions" key="controlpanel">
                        <Panel.Tab heading="parts.mount"> 
                            <TypePicker 
                                title="labels.type"
                                options={typeOptions(mounts)} 
                                selected={mount} 
                                onChange={this.selectMountType} 
                            />
                            <ColorPicker 
                                title="labels.color"
                                options={colorOptions(mounts)} 
                                selected={mount} 
                                onChange={this.selectMountColor} 
                            />
                        </Panel.Tab>
                    </Panel>
                    <div class="limba__controls-prev limba__controls--half"><Button onClick={() => goto('chooseColor')}><span class="konf-icon-Arrow-OutLeft"></span></Button></div>
                    <div class="limba__controls-next limba__controls--half"><Button onClick={() => goto('summary')}><span class="konf-icon-Arrow-OutRight"></span></Button></div>
                </div>
                <Hints />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./js/views/ChooseMount.js